import { Drawer, Typography, Box } from '@mui/material';
import { Close } from '@mui/icons-material';
import {
  BASE_BUTTON_COLOR,
  BASE_BUTTON_VARIANT,
  BaseButton,
} from '~/components/Global/Button';
import { styledUpdateDrawer } from './Drawer.style';
import dayjs from 'dayjs';
import { UpdateStatus } from '~/types/enum';
import { getFileUpdateStatus } from '~/utils/helper/function';

export enum UpdateDrawerAction {
  delete,
  open,
  openPath,
  download,
  update,
}

type TProps = {
  open: boolean;
  onClose: () => void;
  fileName: string;
  uploadedAt: string;
  downloadedAt?: number;
  handleAction: (action: UpdateDrawerAction) => void;
};

export const UpdateDrawer = ({
  open,
  onClose,
  fileName,
  uploadedAt,
  downloadedAt,
  handleAction,
}: TProps) => {
  const updateStatus = getFileUpdateStatus({ uploadedAt, downloadedAt });

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <styledUpdateDrawer.container>
        <styledUpdateDrawer.header>
          電子書資訊
          <Close sx={{ height: '24px', cursor: 'pointer' }} onClick={onClose} />
        </styledUpdateDrawer.header>
        <styledUpdateDrawer.content>
          <Typography fontSize="inherit" sx={{ fontWeight: '700' }}>
            {fileName}
          </Typography>
          <Typography fontSize="inherit" sx={{ color: 'grey.600' }}>
            {updateStatus === UpdateStatus.latest && '目前已是最新版本。'}
            {updateStatus === UpdateStatus.old &&
              `本電子書已於 ${dayjs(uploadedAt).format('YYYY/MM/DD HH:mm')} 發布新版本，請點擊「更新書本」，獲得最新內容。`}
          </Typography>
        </styledUpdateDrawer.content>
        <Box
          sx={{
            padding: '16px 24px',
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
          }}
        >
          {updateStatus === UpdateStatus.old && (
            <BaseButton
              color={BASE_BUTTON_COLOR.SECONDARY}
              variant={BASE_BUTTON_VARIANT.FILLED}
              text="更新"
              width="100%"
              onClick={() => {
                handleAction(UpdateDrawerAction.download);
                onClose();
              }}
            />
          )}
          {(updateStatus === UpdateStatus.old ||
            updateStatus === UpdateStatus.latest) && (
            <>
              <BaseButton
                color={BASE_BUTTON_COLOR.SUCCESS}
                variant={BASE_BUTTON_VARIANT.FILLED}
                text="開啟"
                width="100%"
                onClick={() => {
                  handleAction(UpdateDrawerAction.open);
                }}
              />
              <Box sx={{ display: 'flex', gap: '16px', width: '100%' }}>
                <BaseButton
                  color={BASE_BUTTON_COLOR.PRIMARY}
                  variant={BASE_BUTTON_VARIANT.GHOST}
                  text="開啟檔案位置"
                  width="calc(50% - 8px)"
                  onClick={() => {
                    handleAction(UpdateDrawerAction.openPath);
                  }}
                />
                <BaseButton
                  color={BASE_BUTTON_COLOR.ERROR}
                  variant={BASE_BUTTON_VARIANT.GHOST}
                  text="刪除"
                  width="calc(50% - 8px)"
                  onClick={() => {
                    handleAction(UpdateDrawerAction.delete);
                  }}
                />
              </Box>
            </>
          )}
          {!downloadedAt && (
            <BaseButton
              text="下載"
              width="100%"
              color={BASE_BUTTON_COLOR.PRIMARY}
              variant={BASE_BUTTON_VARIANT.FILLED}
              onClick={() => {
                handleAction(UpdateDrawerAction.download);
                onClose();
              }}
            />
          )}
        </Box>
      </styledUpdateDrawer.container>
    </Drawer>
  );
};
